import React from 'react';
import _ from 'lodash';
import { imagesURL } from 'config';

export default (buttons, globalButtons, translate) => {
  const slots = {};

  buttons.forEach((btn) => {
    const btnObject = typeof btn === 'string' ? { type: btn } : btn;
    const globalButtonAlias = btnObject.globalButtonAlias || btnObject.buttonAlias || btnObject.type;
    const btnDataFromDB = _.find(globalButtons, { alias: globalButtonAlias }) ||
      (btnObject.imageSrc ? { alias: globalButtonAlias, position: btnObject.position, name: btnObject.titleName } : null);

    if (!btnDataFromDB || btnObject.dontShow) return;

    const backgroundImage = `url(${btnObject.imageSrc || `${imagesURL}/GlobalButtons/${btnDataFromDB.imageFilename}`})`;
    const position = btnObject.position || btnDataFromDB.position;
    const titleStringNumber = btnObject.titleStringNumber || btnDataFromDB.stringNumber;
    const titleFallback = btnObject.titleName || btnObject.name || btnDataFromDB.name;

    const buttonHtml = (
      <button
        key={`${btnObject.type}-${btnDataFromDB.alias}`}
        type='button'
        onClick={() => {
          if (btn.beforeClickHandler) {
            btn.beforeClickHandler(btn.onClick);
          } else {
            btn.onClick();
          }
        }}
        disabled={btnObject.disabled}
        title={btnObject.imageSrc && btnObject.titleName ? btnObject.titleName : translate(titleStringNumber, titleFallback, true)}
        style={{ backgroundImage }}
      />
    );

    if (!slots[position]) slots[position] = [];
    slots[position].push({
      html: buttonHtml,
      name: btnDataFromDB.name
    });
  });

  const finalResult = [];

  for (let i = 1; i <= 7; i++) {
    if (slots[i]) {
      const sorted = _.orderBy(slots[i], ['name'], ['asc']);
      sorted.forEach(item => finalResult.push(item.html));
    } else {
      finalResult.push(null);
    }
  }

  return finalResult;
};